<template>
  <div class="history_item">
    <v-list-tile class="history__item--inner">
      <v-layout align-center row
        class="caption" wrap
        :class="paddingClass"
      >
        <v-flex xs12 md2>
          <span class="hidden-md-and-up font-weight-medium">Data operacji:<br/></span>
          {{historyItem.created_at}}
        </v-flex>
        <v-flex xs12 md6>
          <div class="pr-4">
            <span class="hidden-md-and-up font-weight-medium">Typ operacji:<br/></span>
            {{historyItem.description}}
          </div>
        </v-flex>
        <v-flex xs12 md2>
          <span class="hidden-md-and-up font-weight-medium">Użytkownik:<br/></span>
          {{historyItem.user_name}}
        </v-flex>
        <v-flex xs12 md2>
          <span class="hidden-md-and-up font-weight-medium">Adres IP:<br/></span>
          {{historyItem.ip}}
        </v-flex>
      </v-layout>
    </v-list-tile>
    <v-divider v-if="!isLast"></v-divider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'history-item',
  props: ['historyItem', 'index'],
  computed: {
    ...mapGetters('history', [
      'historyList',
    ]),
    isLast() {
      return this.historyList.length - 1 === this.index;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-0 py-2' : 'pa-2';
    },
  },
};
</script>
